import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { PiShareFat } from 'react-icons/pi';
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdCloseCircleOutline,
} from 'react-icons/io';
import { BsPatchCheckFill, BsThreeDotsVertical } from 'react-icons/bs';
import { FaDirections } from 'react-icons/fa';
import { IoExitOutline, IoMusicalNotes } from 'react-icons/io5';
import Dropdown from 'react-bootstrap/Dropdown';
import Spinner from 'react-bootstrap/Spinner';
import Lottie from 'lottie-react';
import animationData from '../live-eye.json';
import { MdKeyboardArrowRight } from 'react-icons/md';
import '../style/Events.css';
import NewUserModal from './NewUserModal';
import { FaSquareArrowUpRight } from 'react-icons/fa6';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';
import { useStatsigClient, useStatsigUser } from '@statsig/react-bindings';
import ShoutoutModal from './Shoutout';
import SocialIconModal from './SocialIconModal';
import EngagementModal from './EngagementModal';
import { ChevronRight } from 'lucide-react';
import GiftModal from './GiftModal';

const Event = () => {
  const [eventid, setEventid] = useState(null);
  const [djDetails, setdjdetails] = useState([]);
  const [mysongs, setMysongsreqs] = useState([]);
  const [myshoutreqs, setMyshoutreqs] = useState([]);
  const [list, setList] = useState(1);
  const [profile, setprofile] = useState([]);
  const [CountUser, setCountUser] = useState(0);
  const [userModal, setUserModal] = useState(false);
  const [notif, setNotif] = useState(false);
  const [notifJoined, setNotifJoined] = useState(false);
  const [notifNameJoined, setNotifNameJoined] = useState('');
  const [confetti, setConfetti] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [songToAdd, setSongToAdd] = useState([]);
  const [songCost, setSongCost] = useState(null);
  const [hearts, setHearts] = useState([]);
  const [heartsInt, setHeartsInt] = useState(2000);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [allHistory, setAllHistory] = useState([]);
  const [liveUsers, setLiveUsers] = useState([]);
  const [userRegistered, setUserRegistered] = useState(true);
  const [name, setName] = useState('');
  const [slotsFull, setSlotsFull] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [allRequests, setAllRequests] = useState([]);
  const [isShoutoutModalOpen, setIsShoutoutModalOpen] = useState(false);
  const [directionModal, setDirectionModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRecipient, setSelectedRecipient] = useState('');
  const [selectedWish, setSelectedWish] = useState('');
  const [selectedUserName, setSelectedUserName] = useState('');
  const [selectedThumbnail, setSelectedThumbnail] = useState('');
  const [requestedUsers, setRequestedUsers] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const notifTimer = useRef(null);
  const prevUserIds = useRef([]);
  const vid = useParams().vid;
  const pid = useParams().pid;
  const { client } = useStatsigClient();
  const { updateUserAsync } = useStatsigUser();

  // Create refs to track ongoing requests and prevent duplicates
  const ongoingRequests = useRef(new Set());
  const lastFetchTimes = useRef({});

  // Helper function to prevent duplicate API calls
  const shouldFetch = (key, minInterval = 1000) => {
    const now = Date.now();
    const lastFetch = lastFetchTimes.current[key] || 0;
    return now - lastFetch >= minInterval;
  };
  const [price, setPrice] = useState([]);
  const displayName = djDetails?.owner?.display_name || 'DJ RockStar';
  const role = displayName.split(' ')[0];
  const animatedTexts =
    djDetails?.isWebPlayer === true
      ? [displayName]
      : [displayName, `Gift ${role} Now`];
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');
  const [showSendSameWishButton, setShowSendSameWishButton] = useState(false);
  const [photoSrc, setPhotoSrc] = useState('');
  const PartnerId = djDetails?.owner?.id;
  const audio = new Audio('/sounds/confetti_sound.mp3');
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedPicture, setselectedPicture] = useState('');

  useEffect(() => {
    if (currentTextIndex >= animatedTexts.length) setCurrentTextIndex(0);
  }, [animatedTexts, currentTextIndex]);

  // Use a ref to track the animation direction (true = forward, false = backward)
  const isForward = useRef(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setCurrentTextIndex(prev => (prev + 1) % animatedTexts.length);
      setIsAnimating(false);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const markFetched = key => {
    lastFetchTimes.current[key] = Date.now();
  };
  useEffect(() => {
    if (!client) return;
    if (!djDetails?.id || !djDetails?.name) return;

    client.logEvent('tringZoneShown', 'Opened', {
      vID: djDetails.id,
      vName: djDetails.name,
      source: localStorage.getItem('isQrEntry') == 'true' ? 'qrScan' : 'null',
      status: djDetails.status,
    });
    // Log once per venue load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, djDetails?.id, djDetails?.name, djDetails?.status]);
  // Consolidated data fetching function
  const fetchVenueData = useCallback(
    async (venueId, isInitialLoad = false) => {
      const requestKey = `venue-${venueId}`;

      if (ongoingRequests.current.has(requestKey)) {
        return; // Prevent duplicate requests
      }

      if (!shouldFetch(requestKey, isInitialLoad ? 0 : 2000)) {
        return; // Rate limiting
      }

      ongoingRequests.current.add(requestKey);
      markFetched(requestKey);

      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        ongoingRequests.current.delete(requestKey);
        return;
      }

      try {
        // Initial requests without allHistory
        const initialRequests = [
          fetch(API_ENDPOINTS.VENUE_BY_ID(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
          fetch(API_ENDPOINTS.VENUE_ALL_REQUESTS(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
          fetch(API_ENDPOINTS.VENUE_USERS_COUNT(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
          fetch(API_ENDPOINTS.VENUE_TRACKS(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
          fetch(API_ENDPOINTS.SHOUTOUT_REQUEST(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
        ];

        const [
          djresponse,
          allRequestsResp,
          countResp,
          mysongreqResp,
          myshoutreqResp,
        ] = await Promise.all(initialRequests);

        // Handle venue data
        if (djresponse.ok) {
          const djData = await djresponse.json();

          if (djData.status === 'finished') {
            localStorage.removeItem('vId');
            localStorage.removeItem('eventid');
            localStorage.removeItem('venueId');
            localStorage.removeItem('venueName');
            localStorage.removeItem('songCost');
            localStorage.removeItem('isKJ');
            localStorage.removeItem('slotsFull');
            localStorage.removeItem('excludedLabels');
            localStorage.setItem('mainInd', 1);
            navigate('/main');
            return;
          }

          setEventid(venueId);
          setdjdetails(djData);
          localStorage.setItem('vId', venueId);
          localStorage.setItem('venueName', djData?.name);
          localStorage.setItem('songCost', djData?.songRequestCoins);
          localStorage.setItem('venueId', djData?.id);
          localStorage.setItem('isKJ', djData?.isKJVenue);
        }

        // Handle allRequests response and check if it's empty
        let allRequestsData = [];
        if (allRequestsResp.ok) {
          const reqData = await allRequestsResp.json();
          allRequestsData = reqData;
          setAllRequests(reqData);
        }

        // Conditionally fetch allHistory only if allRequests is empty
        if (Array.isArray(allRequestsData) && allRequestsData.length === 0) {
          try {
            const allHistoryResp = await fetch(
              API_ENDPOINTS.VENUE_ALL_HISTORY(venueId),
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              }
            );

            if (allHistoryResp.ok) {
              const historyData = await allHistoryResp.json();
              setAllHistory(
                historyData.filter(item => item.status === 'played')
              );
            }
          } catch (historyError) {
            console.error('Error fetching venue history:', historyError);
          }
        }

        // Handle other responses
        if (countResp.ok) {
          const countData = await countResp.json();
          setCountUser(countData?.count);
          if (countData?.count > 1 && countData?.count < 6) {
            setHeartsInt(10000);
          } else if (countData?.count > 5) {
            setHeartsInt(5000);
          }
        }

        if (mysongreqResp.ok) {
          setMysongsreqs(await mysongreqResp.json());
        }

        if (myshoutreqResp.ok) {
          setMyshoutreqs(await myshoutreqResp.json());
        }
      } catch (error) {
        console.error('Error fetching venue data:', error);
      } finally {
        ongoingRequests.current.delete(requestKey);
      }
    },
    [navigate]
  );
  // Add this useEffect to update photoSrc when profile changes
  useEffect(() => {
    if (profile?.avatar) {
      setPhotoSrc(profile.avatar);
    }
  }, [profile?.avatar]);

  // Consolidated user fetching function
  const fetchUsers = useCallback(
    async (venueId, purpose = 'general') => {
      const requestKey = `users-${venueId}-${purpose}`;

      if (ongoingRequests.current.has(requestKey)) {
        return;
      }

      const minInterval = purpose === 'notification' ? 10000 : 10000;
      if (!shouldFetch(requestKey, minInterval)) {
        return;
      }

      ongoingRequests.current.add(requestKey);
      markFetched(requestKey);

      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        ongoingRequests.current.delete(requestKey);
        return;
      }

      try {
        const res = await fetchWithAuth(API_ENDPOINTS.VENUE_USERS(venueId), {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) {
          throw new Error('Failed to fetch users');
        }

        const data = await res.json();
        setLiveUsers(data);

        // Handle notifications only for notification purpose
        if (purpose === 'notification') {
          const myId = profile?.id;
          const prevIds = prevUserIds.current;
          const currIds = data.map(u => u.id);

          const newUsers = data.filter(
            u =>
              !prevIds.includes(u.id) &&
              u.id !== myId &&
              !`${u.first_name ?? ''} ${u.last_name ?? ''}`
                .trim()
                .startsWith('TringBox')
          );

          let toNotify = null;
          if (newUsers.length > 0) {
            toNotify = newUsers[Math.floor(Math.random() * newUsers.length)];
          } else {
            const others = data.filter(
              u =>
                u.id !== myId &&
                !`${u.first_name ?? ''} ${u.last_name ?? ''}`
                  .trim()
                  .startsWith('Tringbox')
            );
            if (others.length > 0) {
              toNotify = others[Math.floor(Math.random() * others.length)];
            }
          }

          if (toNotify) {
            const name = `${toNotify.first_name ?? ''} ${
              toNotify.last_name ?? ''
            }`.trim();
            if (!name.startsWith('TringBox')) {
              setNotifJoined(true);
              setNotifNameJoined(name);
              if (notifTimer.current) clearTimeout(notifTimer.current);
              notifTimer.current = setTimeout(() => {
                setNotifJoined(false);
                setNotifNameJoined('');
              }, 3000);
            }
          }

          prevUserIds.current = currIds;
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setLiveUsers([]);
      } finally {
        ongoingRequests.current.delete(requestKey);
      }
    },
    [profile?.id]
  );
  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await fetchWithAuth(
          API_ENDPOINTS.ORDER_PRICE_BY_VENUE(localStorage.getItem('vId'))
        );
        if (!response.ok) throw new Error('Failed to fetch price');

        const data = await response.json();
        // Filter out hidden packs
        const visiblePacks = data.filter(pack => !pack.isHidden);
        setPrice(visiblePacks);
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };
    fetchPrice();
  }, []);
  // Consolidated profile fetching function
  const fetchProfile = useCallback(async () => {
    const requestKey = 'profile';

    if (ongoingRequests.current.has(requestKey)) {
      return;
    }

    if (!shouldFetch(requestKey, 2000)) {
      return;
    }

    ongoingRequests.current.add(requestKey);
    markFetched(requestKey);

    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      ongoingRequests.current.delete(requestKey);
      return;
    }

    try {
      const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error('Failed to fetch data');

      const data = await response.json();
      setprofile(data);
      setUserRegistered(!data?.isDefaultName);
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      ongoingRequests.current.delete(requestKey);
    }
  }, []);

  // Initial setup effects (unchanged)
  useEffect(() => {
    localStorage.setItem('slotsFull', false);
    if (localStorage.getItem('shoutOutOpen') === 'true') {
      setIsShoutoutModalOpen(true);
    }
  }, []);
  useEffect(() => {
    localStorage.setItem('shoutOutOpen', isShoutoutModalOpen);
  }, [isShoutoutModalOpen]);

  useEffect(() => {
    if (isError) {
      const timeout = setTimeout(() => {
        setIsError(false);
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [isError]);

  // Optimized venue slots availability check
  useEffect(() => {
    if (!djDetails.isKJVenue) return;

    const fetchSlotAvailability = async () => {
      const requestKey = 'slots';

      if (
        ongoingRequests.current.has(requestKey) ||
        !shouldFetch(requestKey, 2000)
      ) {
        return;
      }

      ongoingRequests.current.add(requestKey);
      markFetched(requestKey);

      const token = localStorage.getItem('tringAuthToken');
      const venueId = localStorage.getItem('venueId') || vid;

      try {
        const res = await fetch(
          API_ENDPOINTS.VENUE_SLOTS_AVAILABILITY(venueId),
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!res.ok) return;
        const data = await res.json();
        setSlotsFull(!data.available);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        ongoingRequests.current.delete(requestKey);
      }
    };

    fetchSlotAvailability();
    const intervalId = setInterval(fetchSlotAvailability, 2000);
    return () => clearInterval(intervalId);
  }, [djDetails.isKJVenue, djDetails.numberOfSongs, vid]);

  // Main venue data fetching for vid
  useEffect(() => {
    if (!vid) return;

    fetchVenueData(vid, true);
    const interval = setInterval(() => fetchVenueData(vid), 2000);
    return () => clearInterval(interval);
  }, [vid, fetchVenueData]);

  // User fetching for general purposes
  useEffect(() => {
    if (!vid) return;

    fetchUsers(vid, 'general');
    const interval = setInterval(() => fetchUsers(vid, 'general'), 10000);
    return () => clearInterval(interval);
  }, [vid, fetchUsers]);

  // Main venue data fetching for pid
  useEffect(() => {
    if (!pid) return;

    const fetchEventData = async () => {
      const requestKey = `event-${pid}`;

      if (
        ongoingRequests.current.has(requestKey) ||
        !shouldFetch(requestKey, 2000)
      ) {
        return;
      }

      ongoingRequests.current.add(requestKey);
      markFetched(requestKey);

      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        ongoingRequests.current.delete(requestKey);
        return;
      }

      try {
        const djresponse = await fetch(`${API_ENDPOINTS.VENUES}/${pid}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!djresponse.ok) throw new Error('Failed to fetch venue');

        const text = await djresponse.text();
        console.log('Venue Data:', text);

        if (!text) return;
        const data = JSON.parse(text);

        if (!data?.id) {
          navigate(`/dj?djId=${pid}`, { state: { from: location.pathname } });
          return;
        }

        if (data.status === 'finished') {
          localStorage.removeItem('vId');
          localStorage.removeItem('eventid');
          localStorage.removeItem('venueId');
          localStorage.removeItem('venueName');
          localStorage.removeItem('songCost');
          localStorage.removeItem('isKJ');
          localStorage.removeItem('slotsFull');
          localStorage.removeItem('excludedLabels');
          localStorage.setItem('mainInd', 1);
          navigate('/main');
          return;
        }

        const venueId = data.id;
        setEventid(data?.eventId);
        setdjdetails(data);

        localStorage.setItem('vId', venueId);
        localStorage.setItem('eventid', data?.eventId);
        localStorage.setItem('venueId', venueId);
        localStorage.setItem('venueName', data?.name);
        localStorage.setItem('songCost', data?.songRequestCoins);

        // Fetch additional data in parallel
        const additionalRequests = [
          fetchWithAuth(API_ENDPOINTS.VENUE_USERS(venueId), {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(API_ENDPOINTS.VENUE_ALL_REQUESTS(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
          fetch(API_ENDPOINTS.VENUE_USERS_COUNT(venueId), {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(API_ENDPOINTS.VENUE_TRACKS(venueId), {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(API_ENDPOINTS.SHOUTOUT_REQUEST(venueId), {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(API_ENDPOINTS.VENUE_ALL_HISTORY(venueId), {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }),
        ];

        const [
          liveUserRes,
          allRequestsRes,
          countRes,
          tracksRes,
          shoutoutRes,
          allHistoryResp,
        ] = await Promise.allSettled(additionalRequests);

        // Handle results
        if (liveUserRes.status === 'fulfilled' && liveUserRes.value.ok) {
          const liveUserData = await liveUserRes.value.json();
          setLiveUsers(liveUserData);
        }

        if (allRequestsRes.status === 'fulfilled' && allRequestsRes.value.ok) {
          const requestData = await allRequestsRes.value.json();
          setAllRequests(requestData);
        }
        if (allHistoryResp.status === 'fulfilled' && allHistoryResp.value.ok) {
          const requestData = await allHistoryResp.value.json();
          setAllHistory(requestData.filter(item => item.status === 'played'));
        }
        if (countRes.status === 'fulfilled' && countRes.value.ok) {
          const count = await countRes.value.json();
          setCountUser(count?.count);
          setHeartsInt(
            count?.count > 5 ? 5000 : count?.count > 1 ? 10000 : 2000
          );
        }

        if (tracksRes.status === 'fulfilled' && tracksRes.value.ok) {
          setMysongsreqs(await tracksRes.value.json());
        }

        if (shoutoutRes.status === 'fulfilled' && shoutoutRes.value.ok) {
          setMyshoutreqs(await shoutoutRes.value.json());
        }
      } catch (error) {
        console.error('Error fetching Venue:', error);
      } finally {
        ongoingRequests.current.delete(requestKey);
      }
    };

    fetchEventData();
    const interval = setInterval(fetchEventData, 2000);
    return () => clearInterval(interval);
  }, [pid, navigate, location]);

  // User fetching for notifications
  useEffect(() => {
    if (!vid) return;

    fetchUsers(vid, 'notification');
    const interval = setInterval(() => fetchUsers(vid, 'notification'), 10000);

    return () => {
      clearInterval(interval);
      if (notifTimer.current) clearTimeout(notifTimer.current);
      setNotifJoined(false);
      setNotifNameJoined('');
    };
  }, [vid, fetchUsers]);

  // User registration: wait until venueId exists, then POST once, without throwing
  useEffect(() => {
    const registerUser = async () => {
      const requestKey = 'register-user';

      if (ongoingRequests.current.has(requestKey)) {
        return;
      }

      try {
        const token = localStorage.getItem('tringAuthToken');
        if (!token) {
          return;
        }

        const venueId = vid || localStorage.getItem('venueId');
        console.log('Venue ID:', venueId);
        if (!venueId) return; // first render race: wait until available

        ongoingRequests.current.add(requestKey);
        fetchWithAuth(API_ENDPOINTS.VENUE_USERS(venueId), {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}),
        });
        console.log('API CALL FOR USER');
      } catch (err) {
        console.error(err?.message || err);
      } finally {
        ongoingRequests.current.delete(requestKey);
      }
    };

    registerUser();
  }, [vid]);

  // Profile fetching
  useEffect(() => {
    fetchProfile();
    const interval = setInterval(fetchProfile, 2000);
    return () => clearInterval(interval);
  }, [fetchProfile]);

  // Other effects remain unchanged...
  useEffect(() => {
    if (localStorage.getItem('notif') || localStorage.getItem('confetti')) {
      setNotif(true);
      setConfetti(true);
      const audio = new Audio('/sounds/confetti_sound.mp3');
      audio.play();
      setTimeout(() => {
        setConfetti(false);
      }, 2500);
      localStorage.removeItem('notif');
      localStorage.removeItem('confetti');
    }
  }, []);
  useEffect(() => {
    if (notifJoined) {
      const timer = setTimeout(() => setNotifJoined(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [notifJoined]);

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      localStorage.setItem('isQrEntry', true);
      navigate('/', {
        state: { from: location.pathname },
      });
    }
  }, [navigate, location]);

  // Rest of your functions remain unchanged...
  const triggerConfetti = () => {
    setConfetti(true);
    audio.play();
    setTimeout(() => setConfetti(false), 2500);
  };

  const handleViewMenuClick = () => {
    const venueName = djDetails?.name || '';
    if (client) {
      client.logEvent('menuClicked', 'clicked', {
        vID: djDetails?.id || '',
        vName: djDetails?.name || '',
        source: localStorage.getItem('isQrEntry') == 'true' ? 'qrScan' : 'null',
        status: djDetails.status,
      });
    }
    if (venueName.startsWith('Rude')) {
      navigate('/menu');
    } else {
      navigate('/share', {
        state: {
          scrollToPhotos: true,
          openMenuTab: true,
        },
      });
    }
  };

  const handleAddSong = async () => {
    if (isButtonLoading) return;
    if (client) {
      client.logEvent('addSongClick', 'clicked', {
        vID: djDetails?.id || '',
        vName: djDetails?.name || '',
        source: localStorage.getItem('isQrEntry') == 'true' ? 'qrScan' : 'null',
        status: djDetails.status,
      });
    }
    if (djDetails.status !== 'active' && !djDetails.isKJVenue) {
      setIsError(true);
      setErrorMsg("DJ's taking a break, request will open soon");
      return;
    }

    if (!djDetails.isKJVenue) {
      localStorage.setItem('shoutout', false);
      setIsButtonLoading(false);
      StartAdding();
      return;
    }

    setIsButtonLoading(true);

    try {
      if (slotsFull) {
        setIsError(true);
        setErrorMsg('No more song slots available! Enjoy the performance!');
        return;
      }

      localStorage.setItem('shoutout', false);
      StartAdding();
    } catch (error) {
      console.error('Error checking queue status:', error);
      setIsError(true);
      setErrorMsg('Failed to check queue status. Please try again.');
    } finally {
      setIsButtonLoading(false);
    }
  };

  const ClickOnList = ind => {
    if (ind === 2) setNotif(false);
    setList(ind);
  };

  const StartAdding = () => {
    localStorage.setItem('mainInd', 2);
    navigate('/music');
  };

  const handleShare = async () => {
    const isbuisnessvenue = djDetails.isBussinessVenue;
    if (isbuisnessvenue === true) {
      if (client) {
        client.logEvent('galleryClick', 'clicked', {
          vID: djDetails?.id || '',
          vName: djDetails?.name || '',
          source:
            localStorage.getItem('isQrEntry') == 'true' ? 'qrScan' : 'null',
          status: djDetails.status,
        });
      }
      navigate('/share');
      return;
    }
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Invitation Link for Event',
          url: window.document.location.href,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    }
  };

  const openLiveUserModal = () => {
    if (client) {
      client.logEvent('userEyeButtonClick', 'clicked', {
        vID: djDetails?.id || '',
        vName: djDetails?.name || '',
      });
    }
    navigate(`/live-users/${vid || localStorage.getItem('venueId')}`);
  };

  const cancelUserModal = () => {
    setUserModal(false);
    setShowModal(false);
  };

  const exitEvent = () => {
    localStorage.removeItem('vId');
    localStorage.removeItem('venueId');
    localStorage.removeItem('venueName');
    localStorage.removeItem('eventid');
    localStorage.removeItem('songCost');
    localStorage.removeItem('isKJ');
    localStorage.removeItem('slotsFull');
    localStorage.removeItem('excludedLabels');
    localStorage.setItem('mainInd', 1);
    navigate('/main');
  };

  const skipQueue = async songId => {
    setIsLoading(true);
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      return;
    }

    try {
      const response = await fetchWithAuth(
        API_ENDPOINTS.VENUE_FAST_TRACK(eventid),
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            trackId: songId,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setErrorMsg(errormsg.toString());
        setIsError(true);
        return;
      }

      setConfetti(true);
      setTimeout(() => {
        setConfetti(false);
      }, 2500);
    } catch (error) {
      console.error('Error skipping queue:', error);
    } finally {
      setIsLoading(false);
      setConfirmModal(false);
    }
  };

  const cancelConfirm = () => {
    setSongToAdd([]);
    setConfirmModal(false);
  };

  const openConfirm = song => {
    if (profile.coins < djDetails?.fastTrackCoins) {
      navigate('/insufficient-coins', {
        state: {
          song,
          cost: 100,
          priceData: price,
          fastTrack: true,
          walletCoins: profile.coins,
        },
      });
    } else {
      setSongCost(djDetails?.fastTrackCoins);
      setSongToAdd(song);
      setConfirmModal(true);
    }
  };

  const handleHeartClick = () => {
    const id = Date.now();
    const randomX = Math.random() * 50 + 25;
    const randomY = Math.random() * 40 + 30;
    setHearts(prev => [...prev, { id, x: randomX, y: randomY }]);
    setTimeout(() => {
      setHearts(prev => prev.filter(h => h.id !== id));
    }, 2000);
  };

  const giftDjClicked = () => {
    setShowGiftModal(true);

    if (client) {
      client.logEvent('giftCoinsClicked', 'clicked', {
        vID: djDetails?.id || '',
        vName: djDetails?.name || '',
        source: localStorage.getItem('isQrEntry') == 'true' ? 'qrScan' : 'null',
        status: djDetails.status,
      });
    }
  };

  const openUsers = users => {
    setRequestedUsers(users);
    setUserModal(true);
  };

  if (eventid === null) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100dvh', width: '100dvw' }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{
            color: 'red',
            height: '10dvh',
            aspectRatio: '1/1',
            width: '10dvh',
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const renderQueueItem = (item, index) => {
    if (item.type === 'song') {
      // Existing song rendering logic
      return (
        <div className="d-flex flex-column" key={index}>
          <div className="w-100 d-flex flex-row justify-content-between my-1">
            <div
              className="d-flex flex-row col-9 overflow-hidden"
              style={{ gap: '10px' }}
            >
              {/* Rank / Skipped Badge */}
              {!(
                item?.isFastTrack &&
                item?.users?.some(user => user.id === profile?.id)
              ) ? (
                <span
                  className="justify-content-center align-items-center text-center"
                  style={{
                    maxHeight: 'clamp(0px,12vw,45px)',
                    minWidth: 'clamp(0px,12vw,45px)',
                    border: 'solid 1px #D5D5D5',
                    borderRadius: '10px',
                    color: '#C81622',
                    fontSize: 'clamp(0px,4vw,16px)',
                    aspectRatio: '1/1',
                    display: 'flex',
                    fontWeight: '600',
                  }}
                >
                  {index + 1}
                </span>
              ) : (
                <div
                  className="d-flex flex-column justify-content-center align-items-center text-center"
                  style={{
                    maxHeight: 'clamp(0px,12vw,45px)',
                    minWidth: 'clamp(0px,12vw,45px)',
                    background:
                      'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
                    borderRadius: '10px',
                    fontSize: 'clamp(0px,4vw,16px)',
                    aspectRatio: '1/1',
                  }}
                >
                  <span
                    style={{
                      height: 'clamp(0px,10vw,33px)', // bigger height
                      width: 'clamp(0px,10vw,34px)', // added width for perfect square
                      marginTop: '1px',
                      display: 'flex', // center icon horizontally + vertically
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: 'clamp(0px,8vw,25px)', // larger font size for ⚡
                      lineHeight: 1,
                    }}
                  >
                    ⚡
                  </span>
                  <span
                    style={{
                      color: '#8b4513',
                      fontSize: 'clamp(0px,3vw,9px)', // slightly bigger text
                      marginBottom: '2px',
                      fontStyle: 'italic',
                      fontWeight: '600', // make it more bold
                    }}
                  >
                    Skipped
                  </span>
                </div>
              )}

              {/* Song image */}
              <img
                alt=""
                style={{
                  borderRadius: '10px',
                  height: '100%',
                  maxHeight: 'clamp(0px,12vw,45px)',
                  aspectRatio: '1/1',
                }}
                src={
                  item?.album?.images?.[1]?.url ||
                  item?.album?.images?.[0]?.url ||
                  item?.album?.images?.find(img => img.width === 640)?.url ||
                  item?.album?.images?.find(img => img.height === 640)?.url ||
                  '/images/UnknownSong.png'
                }
              />

              {/* Song title + Skip Queue button below */}
              <div className="text-start">
                <h5
                  style={{
                    color: '#BB1C2D',
                    margin: '0',
                    fontSize: 'clamp(0px,4vw,16px)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '170px',

                    fontWeight: '550',
                  }}
                >
                  {item?.name || 'Unknown Song'}
                </h5>

                {/* Artist + Skip Queue inline */}
                {item?.isFastTrackEligible &&
                item?.users?.some(user => user.id === profile?.id) &&
                index >= 2 ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      marginTop: '2px',
                      maxWidth: '120px',
                      overflow: 'hidden',
                    }}
                  >
                    <button
                      onClick={() => openConfirm(item)}
                      style={{
                        position: 'relative',
                        overflow: 'hidden',
                        background:
                          'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
                        backgroundSize: '400% 400%',
                        border: 'none',
                        color: '#8b4513',
                        borderRadius: '9999px',
                        fontSize: 'clamp(0px, 2.6vw, 10px)',
                        whiteSpace: 'nowrap',
                        padding: '4px 8px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        gap: '2px',
                        boxShadow: '0 2px 4px rgba(255, 215, 0, 0.3)',
                        animation:
                          'skipQueueAppear 0.4s ease-out, gradientWave 4s ease infinite',
                        cursor: 'pointer',
                      }}
                    >
                      <span
                        style={{
                          height: 'clamp(0px, 3vw, 11px)',
                          width: 'clamp(0px, 3vw, 11px)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 'inherit',
                        }}
                      >
                        ⚡
                      </span>
                      <span style={{ fontStyle: 'italic' }}>
                        Skip the Queue
                      </span>
                      {/* shimmer effect span */}
                      <span
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: '-100%',
                          width: '100%',
                          height: '100%',
                          pointerEvents: 'none',
                          background:
                            'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
                          animation: 'skipQueueshimmer 3s linear infinite',
                        }}
                      />
                    </button>
                  </div>
                ) : (
                  /* If no skip queue, show full artist list */
                  <span
                    style={{
                      color: '#868686',
                      fontSize: '10px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: 'block',
                      maxWidth: '120px',
                    }}
                  >
                    {Array.isArray(item?.artists) && item.artists.length > 0
                      ? item.artists.map(a => a?.name).join(', ')
                      : 'Unknown Artist'}
                  </span>
                )}
              </div>
            </div>

            {/* User avatars */}
            <div
              style={{
                overflow: 'hidden',
                textAlign: 'start',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                flex: '0 0 25%',
                maxWidth: '25%',
              }}
            >
              <div
                onClick={() => {
                  openUsers(
                    item?.users?.filter(
                      (user, index, self) =>
                        index === self.findIndex(u => u.id === user.id)
                    ) || []
                  );
                }}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  maxWidth: '300px',
                }}
              >
                {(
                  item?.users?.filter(
                    (user, index, self) =>
                      index === self.findIndex(u => u.id === user.id)
                  ) || []
                )
                  .slice(0, 2)
                  .map((user, idx) => (
                    <div
                      key={user.id || idx}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                      }}
                    >
                      <img
                        alt="user-avatar"
                        style={{
                          borderRadius: '50%',
                          aspectRatio: '1/1',
                          height: 'clamp(0px,8vw,30px)',
                          width: 'clamp(0px,8vw,30px)',
                          marginLeft: idx === 0 ? 0 : -4,
                          objectFit: 'cover',
                        }}
                        src={user?.avatar}
                      />

                      <span
                        style={{
                          color: '#4141414D',
                          fontSize: 'clamp(0px,2.5vw,10px)',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          display: 'block',
                          textAlign: 'center',
                          maxWidth: 'clamp(0px,12vw,50px)',
                          marginBottom: '2px',
                          marginLeft: idx === 0 ? 0 : -4,
                          position: 'relative',
                        }}
                      >
                        {user?.first_name}
                      </span>
                    </div>
                  ))}

                {(
                  item?.users?.filter(
                    (user, index, self) =>
                      index === self.findIndex(u => u.id === user.id)
                  ) || []
                ).length > 2 && (
                  <div
                    style={{
                      marginTop: '4px',
                      aspectRatio: '1/1',
                      marginLeft: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 'clamp(0px,3.5vw,14px)',
                      color: '#C81622',
                    }}
                  >
                    <b>
                      +
                      {(
                        item?.users?.filter(
                          (user, index, self) =>
                            index === self.findIndex(u => u.id === user.id)
                        ) || []
                      ).length - 2}
                    </b>
                  </div>
                )}
              </div>
            </div>
          </div>
          <hr className="my-2" />
        </div>
      );
    } else if (item.type === 'shout-out') {
      return (
        <div
          className="d-flex flex-column"
          key={item._id || index}
          onClick={() => {
            setSelectedRecipient(item.recipientName || 'Anonymous');
            setSelectedWish(item.wish || 'Shout Out');
            setSelectedUserName(item.user?.first_name || 'Anonymous');
            setselectedPicture(item.picture || '');
            setSelectedThumbnail(item.thumbnail || '');
            setSelectedDescription(item.description || '');
            setShowSendSameWishButton(item.showSendSameWishButton);
            setShowModal(true);
          }}
          style={{
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '10px',
            background: '#fff',
          }}
        >
          {/* Shimmer overlay */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
              animation: `shimmer 2s infinite`,
              zIndex: 0,
            }}
          ></div>

          <div className="w-100 d-flex flex-row justify-content-between my-1">
            <div
              className="d-flex flex-row col-9 overflow-hidden"
              style={{ gap: '10px' }}
            >
              <span
                className="justify-content-center align-items-center text-center"
                style={{
                  maxHeight: 'clamp(0px,12vw,45px)',
                  minWidth: 'clamp(0px,12vw,45px)',
                  border: 'solid 1px #D5D5D5',
                  borderRadius: '10px',
                  color: '#C81622',
                  fontSize: 'clamp(0px,4vw,16px)',
                  aspectRatio: '1/1',
                  display: 'flex',
                  fontWeight: '600',
                }}
              >
                {index + 1}
              </span>

              {/* Shoutout thumbnail */}
              <div
                style={{
                  borderRadius: '10px',
                  height: '100%',
                  maxHeight: 'clamp(0px,12vw,45px)',
                  aspectRatio: '1/1',
                  background: item.picture
                    ? `url(${item.picture}) center/cover`
                    : item.thumbnail
                      ? `url(${item.thumbnail}) center/cover`
                      : 'lightgray',
                }}
              />

              <div className="text-start">
                <div
                  style={{
                    maxWidth: '200px', // limit width so it won't cross the thumbnail
                    overflow: item.wish?.length > 18 ? 'hidden' : '', // hide overflow
                    whiteSpace: 'nowrap',
                    position: 'relative',
                  }}
                >
                  <h5
                    style={{
                      animation:
                        item.wish?.length > 18
                          ? 'scrollText 6s linear infinite'
                          : 'gentlePulse 1s ease-in-out infinite 2.1s',
                      color: '#BB1C2D',
                      margin: '0',
                      fontSize: '16px',
                      whiteSpace: 'nowrap',
                      fontWeight: '550',
                    }}
                  >
                    {item.wish || 'Shout Out'}
                  </h5>
                </div>
                <span
                  style={{
                    animation: `gentlePulse 1s ease-in-out infinite 2.1s`,
                    color: '#868686',
                    fontSize: '10px',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    position: 'relative',
                    overflow: 'hidden',
                    zIndex: 1,
                  }}
                >
                  {item.recipientName || 'Anonymous'}
                </span>
              </div>
            </div>

            <div
              style={{
                overflow: 'hidden',
                textAlign: 'start',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                flex: '0 0 25%',
                maxWidth: '25%',
              }}
            >
              {/* User avatar and name */}
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => openUsers([item.user])}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    alt="user-avatar"
                    style={{
                      borderRadius: '50%',
                      aspectRatio: '1/1',
                      height: 'clamp(0px,8vw,30px)',
                      width: 'clamp(0px,8vw,30px)',
                    }}
                    src={item.user?.avatar}
                  />
                  <span
                    style={{
                      marginBottom: '2px',
                      color: '#4141414D',
                      fontSize: 'clamp(0px,2.5vw,10px)',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      display: 'block',
                      textAlign: 'center',
                      maxWidth: 'clamp(0px,12vw,50px)',
                    }}
                  >
                    {item.user?.first_name}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-2" />
        </div>
      );
    } else if (item.type === 'dj-gift') {
      return (
        <div
          className="d-flex flex-column"
          key={item._id || index}
          style={{
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '10px',
            background: '#fff',
          }}
        >
          <div className="w-100 d-flex flex-row justify-content-between my-1">
            <div
              className="d-flex flex-row col-9 overflow-hidden"
              style={{ gap: '10px' }}
            >
              {/* Index badge */}
              <span
                className="justify-content-center align-items-center text-center"
                style={{
                  maxHeight: 'clamp(0px,12vw,45px)',
                  minWidth: 'clamp(0px,12vw,45px)',
                  border: 'solid 1px #D5D5D5',
                  borderRadius: '10px',
                  color: '#C81622',
                  fontSize: 'clamp(0px,4vw,16px)',
                  aspectRatio: '1/1',
                  display: 'flex',
                  fontWeight: '600',
                }}
              >
                {index + 1}
              </span>

              {/* Gift icon thumbnail */}
              <div
                style={{
                  borderRadius: '10px',
                  height: '100%',
                  maxHeight: 'clamp(0px,12vw,45px)',
                  aspectRatio: '1/1',
                  background: `url(${item.thumbnail || '/images/gift.jpg'}) center/cover, linear-gradient(135deg, #ffb6c1, #ff69b4)`,
                }}
              />

              {/* Gift title + coins */}
              <div className="text-start">
                <h5
                  style={{
                    color: '#BB1C2D',
                    margin: '0',
                    fontSize: 'clamp(0px,4vw,16px)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '170px',
                    fontWeight: '550',
                  }}
                >
                  {item.giftTitle ||
                    `Gift to the ${djDetails?.owner?.display_name || 'DJ'}`}
                </h5>
                <span
                  style={{
                    color: '#868686',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {item.giftDescription || `${item.coins || 'Gifted'} Coins`}
                </span>
              </div>
            </div>

            {/* User avatar */}
            <div
              style={{
                overflow: 'hidden',
                textAlign: 'start',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                flex: '0 0 25%',
                maxWidth: '25%',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => openUsers([item.user])}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    alt="user-avatar"
                    style={{
                      borderRadius: '50%',
                      aspectRatio: '1/1',
                      height: 'clamp(0px,8vw,30px)',
                      width: 'clamp(0px,8vw,30px)',
                    }}
                    src={item.user?.avatar}
                  />
                  <span
                    style={{
                      marginBottom: '2px',
                      color: '#4141414D',
                      fontSize: 'clamp(0px,2.5vw,10px)',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      display: 'block',
                      textAlign: 'center',
                      maxWidth: 'clamp(0px,12vw,50px)',
                    }}
                  >
                    {item.user?.first_name}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-2" />
        </div>
      );
    }
  };

  const UserModal = ({ user, onClose }) => {
    if (!user) return null;
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'black',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 10000,
        }}
      >
        {/* Header with back arrow + name */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px',
          }}
        >
          <IoIosArrowBack
            style={{
              fontSize: '31px',
              cursor: 'pointer',
              color: '#fff',
            }}
            onClick={onClose}
          />
          <span style={{ fontSize: '21px', fontWeight: '500' }}>
            {user.first_name} {user.last_name}
          </span>
        </div>

        {/* Centered profile picture */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={user.avatar || '/default-avatar.png'}
            alt={`${user.first_name || ''} ${user.last_name || ''}`}
            style={{
              borderRadius: '50%',
              width: 200,
              height: 200,
              objectFit: 'cover',
              border: '3px solid white',
              marginBottom: '140px',
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      {!userRegistered && (
        <NewUserModal
          defaultName={name}
          onClose={() => setUserRegistered(true)}
          onRegistered={finalName => {
            setName(finalName || '');
            setUserRegistered(true);
          }}
          updateUserAsync={updateUserAsync}
        />
      )}
      {notifJoined &&
        notifNameJoined &&
        (djDetails.status === 'active' ||
          (djDetails.status === 'approved' && djDetails.isKJVenue)) &&
        liveUsers.length > 2 && (
          <div
            style={{
              position: 'fixed',
              bottom: '75px',
              left: '50%',
              transform: 'translateX(-50%)',
              backdropFilter: 'blur(10px)',
              borderRadius: '10px',
              padding: '4px 12px',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 600,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.35)',
              fontSize: '16px',
              gap: '10px',
              animation: 'floatUpAndFade 1.2s ease-out forwards',
              whiteSpace: 'nowrap', // Prevents text from wrapping to a new line
            }}
          >
            {notifNameJoined} joined!
          </div>
        )}

      <div
        className="position-relative d-flex flex-column"
        style={{ height: '100dvh' }}
      >
        {confirmModal && profile.coins >= songCost && (
          <div className="position-relative">
            <div className="overlay" onClick={cancelConfirm}></div>
            <div
              className="modale-content"
              style={{
                maxWidth: '500px', // centers & limits width on desktop
                margin: '0 auto',
                borderRadius: '15px',
                overflow: 'hidden',
              }}
            >
              <div
                className="w-100 p-3 d-flex flex-row"
                style={{
                  borderRadius: '15px 15px 0px 0px',
                  background:
                    'linear-gradient(90deg, #C91721 40%, #8A325D 100%)',
                }}
              >
                <div className="col-3"></div>
                <div className="col-9 d-flex flex-row justify-content-between">
                  <h4 className="m-0" style={{ color: 'white' }}>
                    Skip Queue
                  </h4>
                  <button
                    style={{
                      color: 'white',
                      background: 'transparent',
                      border: 'none',
                    }}
                    onClick={cancelConfirm}
                  >
                    <IoMdCloseCircleOutline
                      style={{ color: 'white', fontSize: '25px' }}
                    />
                  </button>
                </div>
              </div>

              {songToAdd && (
                <div className="w-100">
                  <div
                    className="px-3 py-4 w-100"
                    style={{ background: '#FFF' }}
                  >
                    <div className="d-flex flex-row justify-content-between align-items-center">
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{ gap: '15px' }}
                      >
                        <img
                          src={songToAdd?.album?.images[0]?.url}
                          style={{
                            height: 'clamp(50px, 6vw, 60px)',
                            width: 'clamp(50px, 6vw, 60px)',
                            borderRadius: '50%',
                          }}
                        />
                        <span
                          style={{
                            color: '#9F2A4A',
                            fontSize: 'clamp(14px, 4vw, 18px)',
                          }}
                          className="text-start col-8"
                        >
                          {songToAdd?.name}
                        </span>
                      </div>
                      <div className="text-center">
                        <img
                          src="/images/coin.svg"
                          style={{
                            width: 'clamp(20px, 5vw, 30px)',
                            aspectRatio: '1/1',
                          }}
                        />
                        <h4
                          style={{
                            color: '#9F2A4A',
                            fontSize: 'clamp(14px, 4vw, 18px)',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {songCost} coins
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-row justify-content-between align-items-center w-100">
                    <button
                      className="col-6 p-2"
                      style={{
                        background: '#FFF',
                        color: '#C71823',
                        border: 'solid .5px #C71823',
                        borderRadius: '0px 0px 0px 15px',
                        fontSize: '18px',
                      }}
                      onClick={cancelConfirm}
                    >
                      Cancel
                    </button>
                    <button
                      className="col-6 p-2"
                      style={{
                        background:
                          'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                        color: 'white',
                        border: 'solid .5px #C71823',
                        borderRadius: '0px 0px 15px 0px',
                        fontSize: '18px',
                      }}
                      onClick={() => skipQueue(songToAdd.id)}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {userModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100svh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1050,
            }}
          >
            <div
              onClick={cancelUserModal}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                top: 0,
                left: 0,
                zIndex: 1055,
              }}
            />
            <div
              style={{
                position: 'relative',
                zIndex: 1060,
                backgroundColor: 'white',
                padding: '0rem',
                borderRadius: '10px',
                width: '90%',
                maxWidth: '500px',
                maxHeight: '80vh',
                overflow: 'hidden',
                boxShadow: '0px 4px 20px rgba(0,0,0,0.3)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  position: 'sticky',
                  top: 0,
                  backgroundColor: 'white',
                  zIndex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1rem',
                  borderBottom: '1px solid #ddd',
                }}
              >
                <span></span>
                <h2
                  style={{ margin: 0, color: '#C81622', textAlign: 'center' }}
                >
                  Requested By
                </h2>
                <IoMdCloseCircleOutline
                  onClick={cancelUserModal}
                  style={{
                    color: 'black',
                    fontSize: 'clamp(0px, 5vw, 25px)',
                    cursor: 'pointer',
                  }}
                />
              </div>
              <div style={{ overflowY: 'auto', padding: '1rem' }}>
                {requestedUsers.map((user, index) => (
                  <div key={index}>
                    <div
                      className="w-100 d-flex flex-row align-items-center py-1"
                      style={{ gap: '10px' }}
                      onClick={() => setSelectedUser(user)}
                    >
                      <img
                        style={{
                          borderRadius: '50%',
                          aspectRatio: '1/1',
                          height: 'clamp(0px,10vw,38px)',
                          width: 'clamp(0px,10vw,38px)',
                        }}
                        src={user?.avatar}
                      />
                      <span
                        style={{
                          fontSize: 'clamp(0px,4vw,16px)',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {user?.first_name} {user?.last_name}
                      </span>

                      {/* ✅ Arrow pushed to the right */}
                      <IoIosArrowForward
                        style={{
                          fontSize: '20px',
                          color: 'grey',
                          marginLeft: 'auto',
                        }}
                      />
                    </div>
                    <hr className="my-2" />
                  </div>
                ))}
              </div>
              <UserModal
                user={selectedUser}
                onClose={() => setSelectedUser(null)}
              />
            </div>
          </div>
        )}

        {isError && (
          <div
            style={{
              position: 'fixed',
              bottom: '80px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 10000,
              color: 'white',
              background: 'rgba(236, 236, 236, 1)',
              borderRadius: '20px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.32)',
              padding: '16px 24px',
              minWidth: '300px',
              maxWidth: '90vw',
              animation: 'slideDown 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <img
              src="/images/logo.svg"
              style={{ width: '18px', height: '18px', flexShrink: 0 }}
            />
            <div
              style={{
                color: 'black',
                fontSize: '13px',
                lineHeight: '1.4',
                textAlign: 'start',
              }}
            >
              {typeof errorMsg === 'string'
                ? errorMsg
                : errorMsg?.message || 'Something went wrong'}
            </div>
          </div>
        )}

        {isLoading && (
          <div className="lmodale">
            <div className="loverlay"></div>
            <div className="lmodalecontent">
              <Spinner
                animation="border"
                role="status"
                style={{ color: 'red' }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </div>
        )}

        {hearts.map(heart => (
          <img
            key={heart.id}
            src="/images/heart_gif.gif"
            alt="heart"
            className="floating-heart"
            style={{ top: `${heart.y}%`, left: `${heart.x}%` }}
          />
        ))}

        <img
          src="/images/confetti.gif"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: 2000,
            display: confetti ? 'block' : 'none',
          }}
        />

        <div
          className="d-flex flex-column justify-content-start"
          style={{ height: 'fit-content', gap: '.5vh', zIndex: 0 }}
        >
          <div
            className="w-100 position-relative"
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${djDetails.photoUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              height: '8vh',
            }}
          >
            {/* Back Button - Extreme Left */}
            <button
              onClick={() => {
                localStorage.setItem('mainInd', '1');
                navigate('/main');
              }}
              style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'transparent',
                border: 'none',
                padding: 0,
              }}
            >
              <IoIosArrowBack
                style={{ color: 'white', fontSize: 'clamp(0px,6.5vw,28px)' }}
              />
            </button>

            {/* Share / Explore - Centered */}
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              {djDetails?.isBussinessVenue ? (
                <button
                  style={{
                    background: 'transparent',
                    border: 'none',
                    fontSize: 'clamp(0px,4.8vw,18px)',
                    fontStyle: 'italic',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '4px 8px',
                  }}
                  onClick={handleShare}
                >
                  <span
                    style={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: '600',
                    }}
                  >
                    Gallery
                  </span>
                  <FaSquareArrowUpRight
                    size={12}
                    color="rgba(255, 255, 255, 0.8)"
                  />
                </button>
              ) : (
                <button
                  style={{
                    background: 'transparent',
                    border: 'none',
                    fontSize: 'clamp(0px,4.8vw,18px)',
                    fontStyle: 'italic',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '4px 8px',
                  }}
                  onClick={handleShare}
                >
                  <PiShareFat
                    style={{
                      fontSize: '16px',
                      color: 'rgba(255, 255, 255, 0.8)',
                    }}
                  />
                  <span
                    style={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: '600',
                    }}
                  >
                    Share
                  </span>
                </button>
              )}
            </div>

            {/* Right section: Buy Coins + 3-Dots */}
            <div
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* Buy Coins Button */}
              <button
                onClick={() => navigate('/buy')}
                style={{
                  border: '1.321px solid #FED111',
                  borderRadius: '20px',
                  color: 'white',
                  height: '20px',
                  background: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 'clamp(0px,4.8vw,15px)',
                  padding: '0px 8px 0px 0.3px', // No left padding
                  overflow: 'hidden',
                }}
              >
                <img
                  src="/images/coin.svg"
                  style={{
                    height: '16px',
                    width: '16px',
                    marginRight: '2px',
                    marginBottom: '0.5px',
                  }}
                />
                {profile?.coins || 0}
              </button>

              {/* Dropdown Menu */}
              <Dropdown>
                <Dropdown.Toggle
                  className="drop-toggle"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                  }}
                >
                  <BsThreeDotsVertical
                    style={{
                      color: 'white',
                      fontSize: 'clamp(0px,6.5vw,28px)',
                    }}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setDirectionModal(true)}>
                    <FaDirections
                      className="mb-1"
                      style={{ color: '#d7080c' }}
                    />{' '}
                    Directions
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={async () => {
                      if (navigator.share) {
                        try {
                          await navigator.share({
                            title: 'Invitation Link for Event',
                            url: window.document.location.href,
                          });
                        } catch (err) {
                          console.error('Error sharing:', err);
                        }
                      }
                    }}
                  >
                    <PiShareFat className="mb-1" style={{ color: '#d7080c' }} />{' '}
                    Share Venue
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exitEvent}>
                    <IoExitOutline
                      className="mb-1"
                      style={{ color: '#d7080c' }}
                    />{' '}
                    Exit
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-between w-100 px-3 mt-1 pt-0.5">
            <h3
              className="m-0 col-10 text-start d-flex align-items-center"
              style={{
                color: '#d7080c',
                gap: '3px',
                fontSize: 'clamp(0px,5vw,22px)',
              }}
            >
              <span
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'inline-block',
                  maxWidth: '100%',
                  fontWeight: 550,
                }}
              >
                {djDetails?.name || ''}
              </span>

              {djDetails?.isBussinessVenue && (
                <BsPatchCheckFill
                  style={{ color: '#2196f3', fontSize: '20px', flexShrink: 0 }}
                />
              )}
            </h3>

            <span
              onClick={() => {
                // Navigate to the live users page for this venue
                openLiveUserModal();
              }}
              style={{
                marginTop: '3px',
                height: '20px',
                minWidth: '48px',
                background:
                  'linear-gradient(90deg, #C71722 -2.99%, #8E315B 113.48%)',
                borderRadius: '8px',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0 10px',
                fontSize: '13px',
                color: 'white',
                fontWeight: 600,
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  width: 20,
                  height: 20,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden',
                }}
              >
                <Lottie
                  animationData={animationData}
                  loop
                  autoplay
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: '4px',
                  }}
                />
              </div>
              {CountUser}
            </span>
          </div>
          <div
            className="d-flex flex-row align-items-center"
            style={{ minHeight: '16px', marginTop: '4px', marginBottom: 0 }}
          >
            {djDetails?.status === 'active' ||
            djDetails?.status === 'paused' ||
            djDetails.isKJVenue ? (
              <>
                <span
                  className="d-flex align-items-center"
                  style={{
                    background:
                      djDetails?.status === 'active'
                        ? '#0F6D01'
                        : djDetails?.status === 'paused'
                          ? '#FFA500'
                          : 'linear-gradient(90deg, #C71722 -2.99%, #8E315B 113.48%)',
                    color: 'white',
                    borderRadius:
                      djDetails.isBussinessVenue && djDetails?.startAt
                        ? '4px 4px 4px 4px'
                        : '4px 0 0 4px',
                    fontWeight: 400,
                    fontSize: '14px',
                    padding: '2px 12px',
                    minWidth: '54px',
                    marginLeft: '15px',
                    height: '17px',
                    display: 'flex',
                  }}
                >
                  {djDetails?.status === 'active'
                    ? 'Live'
                    : djDetails?.status === 'approved'
                      ? 'Upcoming'
                      : djDetails?.status === 'paused'
                        ? 'Paused'
                        : ''}
                </span>
                {djDetails?.endAt && !djDetails.isBussinessVenue && (
                  <span
                    className="d-flex align-items-center"
                    style={{
                      color: 'black',
                      fontSize: '12px',
                      fontWeight: 300,
                      padding: '2px 5px',
                      height: '17px',
                      display: 'flex',
                      border: 'solid 1px #888',
                      borderRadius: '0px 4px 4px 0px',
                    }}
                  >
                    {djDetails.status === 'approved'
                      ? `${new Date(djDetails.startAt).toLocaleString('en-US', {
                          day: '2-digit',
                          month: 'short',
                        })}, ${new Date(djDetails.startAt).toLocaleString(
                          'en-US',
                          {
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true,
                          }
                        )}`
                      : `Till ${new Date(djDetails.endAt).toLocaleString(
                          'en-US',
                          {
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true,
                          }
                        )}`}
                  </span>
                )}
                {djDetails.isBussinessVenue && (
                  <button
                    className="d-flex align-items-center"
                    onClick={handleViewMenuClick}
                    style={{
                      background:
                        'linear-gradient(90deg, rgba(223, 29, 42, 0.42) -2.99%, rgba(255, 255, 255, 0.71) 113.48%)',
                      color: 'red',
                      borderRadius: '4px',
                      fontWeight: 400,
                      fontSize: '14px',
                      border: 'none',
                      boxShadow: 'none',
                      outline: 'none',
                      padding: '2px 12px',
                      minWidth: '54px',
                      marginLeft: '4px',
                      height: '17px',
                      display: 'flex',
                      gap: '4px',
                    }}
                  >
                    View Menu
                    <FaSquareArrowUpRight />
                  </button>
                )}
              </>
            ) : djDetails?.isBussinessVenue ? (
              <>
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#222',
                    marginLeft: '16px',
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate('/share?scrollToRatings=1')}
                >
                  {djDetails.rating ? djDetails.rating.toFixed(1) : '0.0'}
                </span>

                <span
                  className="d-flex align-items-center"
                  style={{ marginLeft: '4px', cursor: 'pointer' }}
                  onClick={() => navigate('/share?scrollToRatings=1')}
                >
                  {Array.from({ length: 5 }).map((_, i) => {
                    const rating = parseFloat(djDetails.rating) || 0;
                    let fill = '#E0E0E0';
                    let gradientId = `star-gradient-${i}`;
                    let useGradient = false;
                    if (i + 1 <= Math.floor(rating)) {
                      fill = '#FFD700';
                    } else if (i < rating && rating < i + 1) {
                      useGradient = true;
                    }
                    return useGradient ? (
                      <svg
                        key={i}
                        width="16"
                        height="16"
                        viewBox="0 0 20 20"
                        style={{
                          marginRight: i === 4 ? 0 : 2,
                          display: 'inline-block',
                        }}
                      >
                        <defs>
                          <linearGradient id={gradientId}>
                            <stop
                              offset={`${((rating - i) * 100).toFixed(0)}%`}
                              stopColor="#FFD700"
                            />
                            <stop
                              offset={`${((rating - i) * 100).toFixed(0)}%`}
                              stopColor="#E0E0E0"
                            />
                          </linearGradient>
                        </defs>
                        <polygon
                          points="10,1 12.59,7.36 19.51,7.36 13.96,11.63 16.55,17.99 10,13.72 3.45,17.99 6.04,11.63 0.49,7.36 7.41,7.36"
                          fill={`url(#${gradientId})`}
                        />
                      </svg>
                    ) : (
                      <svg
                        key={i}
                        width="16"
                        height="16"
                        viewBox="0 0 20 20"
                        style={{
                          marginRight: i === 4 ? 0 : 2,
                          display: 'inline-block',
                        }}
                      >
                        <polygon
                          points="10,1 12.59,7.36 19.51,7.36 13.96,11.63 16.55,17.99 10,13.72 3.45,17.99 6.04,11.63 0.49,7.36 7.41,7.36"
                          fill={fill}
                        />
                      </svg>
                    );
                  })}
                </span>
                <span style={{ fontSize: '13px', color: '#666' }}>
                  (
                  {djDetails?.user_ratings_total > 100
                    ? (djDetails.user_ratings_total / 1000).toFixed(1) + 'k'
                    : djDetails?.user_ratings_total || 0}
                  )
                </span>
              </>
            ) : (
              <>
                <span
                  style={{
                    fontWeight: 400,
                    fontSize: '14px',
                    color: 'white',
                    marginLeft: '16px',
                    background: '#D0151C',
                    padding: '2px 6px',
                    height: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '4px 0 0 4px',
                  }}
                >
                  Upcoming
                </span>
                {djDetails?.startAt && (
                  <span
                    className="d-flex align-items-center"
                    style={{
                      color: 'black',
                      fontSize: '12px',
                      fontWeight: 300,
                      padding: '2px 5px',
                      height: '16px',
                      display: 'flex',
                      border: 'solid 1px #888',
                      borderRadius: '0px 4px 4px 0px',
                    }}
                  >
                    {new Date(djDetails.startAt).toLocaleString('en-US', {
                      hour: 'numeric',
                      minute: '2-digit',
                      hour12: true,
                      month: 'short',
                      day: 'numeric',
                    })}
                  </span>
                )}
              </>
            )}
          </div>
          <button
            style={{
              marginBottom: '0.5rem',
              marginTop: '0.5rem',
              padding: 0,
              marginLeft: '0.75rem',
              marginRight: '0.75rem',
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '10px',
              background:
                'linear-gradient(90deg, #40286C 0.02%, #9A2B4F 99.98%)',
              height: '12vh',
              transition: 'transform 0.2s ease',
              overflow: 'hidden',
              zIndex: -1,
              maxWidth: '100%',
            }}
            onClick={giftDjClicked}
          >
            {/* Left disc */}
            <img
              style={{
                position: 'absolute',
                left: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                aspectRatio: '1 / 1',
                width: 'clamp(0px,27vw,100px)',
                filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
              }}
              src="/images/disc.gif"
              alt="DJ Disc"
            />

            {/* Center content */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                textAlign: 'center',
                position: 'relative',
              }}
            >
              <h2
                style={{
                  position: 'relative',
                  color: 'white',
                  fontSize:
                    djDetails?.isWebPlayer === true
                      ? '15px'
                      : 'clamp(14px, 6vw, 20px)',
                  whiteSpace: 'nowrap',
                  textShadow: '0 2px 4px rgba(0,0,0,0.4)',
                  margin: 0,
                }}
              >
                <span
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    overflow: 'hidden', // restrict shimmer to text width
                  }}
                >
                  {animatedTexts[currentTextIndex]}

                  {animatedTexts[currentTextIndex] === `Gift ${role} Now` &&
                    !isAnimating && (
                      <span
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          background:
                            'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%)',
                          borderRadius: '4px',
                          animation: 'shimmer 3s infinite',
                          pointerEvents: 'none',
                        }}
                      />
                    )}
                </span>
              </h2>

              {/* Arrow */}
              {animatedTexts[currentTextIndex] === `Gift ${role} Now` &&
                !isAnimating && (
                  <ChevronRight
                    size={20}
                    style={{
                      marginLeft: '2px',
                      marginBottom: '2px',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                      color: 'white',
                    }}
                  />
                )}
            </div>

            {/* Right disc */}
            <img
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                aspectRatio: '1 / 1',
                width: 'clamp(0px,27vw,100px)',
                filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
              }}
              src="/images/disc.gif"
              alt="DJ Disc"
            />
          </button>
        </div>

        <div
          className="w-100 px-3 d-flex flex-column"
          style={{ flexGrow: 1, overflow: 'auto' }}
        >
          <div
            className="w-100 d-flex flex-row"
            style={{ borderBottom: 'solid 1px #A1A1A133' }}
          >
            <span
              onClick={() => ClickOnList(1)}
              className="w-50 py-2"
              style={{
                color: list === 1 ? '#BF1A2A' : '#41414180',
                borderBottom:
                  list === 1 ? 'solid 2px #C11A28' : 'solid 1px #41414180',
                fontFamily: 'sans-serif',
                fontWeight: '510',
              }}
            >
              {allRequests.length === 0 && allHistory.length
                ? 'Recently Played'
                : 'Queue'}
            </span>
            <span
              onClick={() => ClickOnList(2)}
              className="w-50 py-2 d-flex flex-row justify-content-center align-items-center"
              style={{
                color: list === 2 ? '#BF1A2A' : '#41414180',
                borderBottom:
                  list === 2 ? 'solid 2px #C11A28' : 'solid 1px #41414180',
                fontWeight: '560',
              }}
            >
              My Request{' '}
              <span
                className="mt-1"
                style={{
                  padding: '6px',
                  borderRadius: '50%',
                  backgroundColor: '#9A2B4F',
                  marginLeft: '10px',
                  display: notif ? 'flex' : 'none',
                }}
              ></span>
            </span>
          </div>

          <div
            className="w-100"
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              scrollBehavior: 'smooth',
              flexGrow: 1,
              // Ensure last list item stays above the fixed footer (70px height + 10px top padding + 2vh bottom padding)
              marginBottom: 'calc(70px )',
              marginTop: '5px',
            }}
          >
            {list === 1 ? (
              <div className="h-100 ">
                {allRequests.length > 0 ? (
                  <div className="mt-1">
                    {allRequests.map((item, index) =>
                      renderQueueItem(item, index)
                    )}
                  </div>
                ) : allRequests.length === 0 && allHistory.length > 0 ? (
                  <div className="mt-1">
                    {allHistory.map((item, index) =>
                      renderQueueItem(item, index)
                    )}
                  </div>
                ) : (
                  <div className="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
                    {djDetails.status === 'active' ||
                    !djDetails.isBussinessVenue ? (
                      <img
                        src="/images/EmptyList.svg"
                        style={{ width: '40%' }}
                      />
                    ) : (
                      <img src="/images/pasta.svg" style={{ width: '40%' }} />
                    )}
                    <span
                      className="mt-2"
                      style={{
                        color: '#4141414D',
                        fontSize: '20px',
                        fontWeight: '500',
                      }}
                    >
                      {!djDetails.isKJVenue &&
                        (djDetails.status === 'active' ? (
                          'Accepting Song Requests. Send your tracks Now!'
                        ) : djDetails.isBussinessVenue ? (
                          <>
                            While the DJ’s on break, <br /> why not vibe with
                            our flavors?
                          </>
                        ) : (
                          <>
                            DJ's taking a break,
                            <br /> Requests will open soon!
                          </>
                        ))}

                      {slotsFull && (
                        <>
                          No more song slots available! Enjoy the performances!
                        </>
                      )}
                      {djDetails.isKJVenue && !slotsFull && (
                        <>
                          Ready to sing? Add your karaoke song and lock your
                          slot!
                        </>
                      )}
                      {/* <span
                          style={{
                            color: "#BD1C2C",
                            background:
                              "linear-gradient(90deg,rgba(175, 33, 43, 0.29) -2.99%,rgba(255, 255, 255, 0.44) 113.48%)",
                            padding: "2px 6px 2px 6px",
                            borderRadius: "10px",
                          }}
                        >
                          <img
                            src="/images/tray(1).png"
                            style={{
                              width: "16px",
                              marginBottom: "3px",
                              marginRight: "3px",
                            }}
                          />
                          Menu
                        </span> */}
                    </span>

                    {djDetails.isBussinessVenue &&
                      djDetails.status !== 'active' && (
                        <button
                          style={{
                            color: '#C11A28',
                            background: 'none',
                            marginTop: '10px',
                            border: 'none',
                            fontSize: 'clamp(12px, 4vw, 16px)',
                            padding: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onClick={handleViewMenuClick}
                        >
                          <img
                            src="/images/tray(1).png"
                            style={{
                              width: '16px',
                              marginBottom: '2px',
                              marginRight: '3px',
                            }}
                          />
                          View Menu
                          <MdKeyboardArrowRight />
                        </button>
                      )}
                  </div>
                )}
              </div>
            ) : (
              <div className="h-100 w-100">
                {myshoutreqs.length === 0 ? (
                  <div></div>
                ) : (
                  <div className="mt-2">
                    {myshoutreqs.map((shouts, index) => (
                      <div key={index}>
                        <div className="w-100 d-flex flex-row justify-content-between">
                          <div
                            className="d-flex flex-row col-8 overflow-hidden"
                            style={{ gap: '15px' }}
                          >
                            <img
                              style={{
                                borderRadius: '10px',
                                height: '100%',
                                maxHeight: 'clamp(0px,12vw,45px)',
                                aspectRatio: '1/1',
                              }}
                              src={
                                shouts?.picture ||
                                shouts?.thumbnail ||
                                '/images/shout.svg'
                              }
                              alt="shout"
                            />

                            <div className="text-start">
                              <h4
                                style={{
                                  color: '#BB1C2D',
                                  fontSize: 'clamp(0px,3.7vw,15px)',
                                  fontWeight: 550,
                                  margin: '0',
                                }}
                              >
                                {shouts?.wish || ''}
                              </h4>
                              <span
                                style={{
                                  color: '#868686',
                                  fontSize: 'clamp(0px,3.7vw,14px)',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {shouts?.recipientName || ''}
                              </span>
                            </div>
                          </div>
                          {/* <div className="text-start col-3 d-flex flex-column justify-content-center align-items-center">
                            <h5
                              style={{
                                color: '#BB1C2D',
                                fontSize: 'clamp(0px,3.5vw,12px)',
                                whiteSpace: 'nowrap',
                                marginBottom: '0',
                                textAlign: 'center',
                              }}
                            >
                              {shouts?.status
                                ? shouts.status.charAt(0).toUpperCase() +
                                  shouts.status.slice(1)
                                : ''}
                            </h5>
                          </div> */}
                          <div
                            style={{
                              width: '35%',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'center',
                            }}
                          >
                            <h5
                              style={{
                                color: '#BB1C2D',
                                fontSize: 'clamp(0px,3.5vw,12px)',
                                marginBottom: 0,
                                whiteSpace: 'nowrap',
                                fontWeight: 550,
                              }}
                            >
                              {shouts?.status === 'rejected'
                                ? 'Declined'
                                : shouts?.status
                                  ? shouts.status.charAt(0).toUpperCase() +
                                    shouts.status.slice(1)
                                  : ''}
                            </h5>
                            {shouts?.status === 'rejected' && (
                              <span
                                style={{
                                  fontSize: 'clamp(0px,3.2vw,9px)',
                                  color: '#868686',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Reason: Vibe mismatch
                              </span>
                            )}
                          </div>
                        </div>
                        <hr className="my-2" />
                      </div>
                    ))}
                  </div>
                )}
                {mysongs.length === 0 && myshoutreqs.length === 0 ? (
                  <div
                    className="w-100 d-flex flex-column align-items-center justify-content-center"
                    style={{ height: '100%' }}
                  >
                    {djDetails.status === 'active' ||
                    !djDetails.isBussinessVenue ? (
                      <img
                        src="/images/EmptyList.svg"
                        style={{ width: '40%' }}
                      />
                    ) : (
                      <img src="/images/pasta.svg" style={{ width: '40%' }} />
                    )}
                    <span
                      className="mt-2"
                      style={{
                        color: '#4141414D',
                        fontSize: '20px',
                        fontWeight: '550',
                      }}
                    >
                      {!djDetails.isKJVenue &&
                        (djDetails.status === 'active' ? (
                          'Accepting Song Requests. Send your tracks Now!'
                        ) : djDetails.isBussinessVenue ? (
                          <>
                            While the DJ’s on break, <br /> why not vibe with
                            our flavors?
                          </>
                        ) : (
                          <>
                            DJ's taking a break,
                            <br /> Requests will open soon!
                          </>
                        ))}
                      {djDetails.isKJVenue && !slotsFull && (
                        <>
                          Ready to sing? Add your karaoke song and lock your
                          slot!
                        </>
                      )}
                      {djDetails.isKJVenue && slotsFull && (
                        <>
                          No more song slots available! Enjoy the performances!
                        </>
                      )}
                    </span>
                    {djDetails.isBussinessVenue &&
                      djDetails.status !== 'active' && (
                        <button
                          style={{
                            color: '#C11A28',
                            background: 'none',
                            marginTop: '10px',
                            border: 'none',
                            fontSize: 'clamp(12px, 4vw, 16px)',
                            padding: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onClick={() => (window.location.href = '/menu')}
                        >
                          <img
                            src="/images/tray(1).png"
                            style={{
                              width: '16px',
                              marginBottom: '2px',
                              marginRight: '3px',
                            }}
                          />
                          View Menu
                          <MdKeyboardArrowRight />
                        </button>
                      )}
                  </div>
                ) : (
                  <div style={{ marginTop: '0.5rem' }}>
                    {mysongs.map((song, index) => (
                      <div key={index}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              overflow: 'hidden',
                              gap: '15px',
                              width: '66.66%',
                            }}
                          >
                            <img
                              style={{
                                borderRadius: '10px',
                                maxHeight: 'clamp(0px,12vw,45px)',
                                aspectRatio: '1',
                                objectFit: 'cover',
                              }}
                              src={
                                song?.album?.images?.[1]?.url ||
                                song?.album?.images?.[0]?.url ||
                                song?.album?.images?.find(
                                  img => img.width === 640
                                )?.url ||
                                song?.album?.images?.find(
                                  img => img.height === 640
                                )?.url ||
                                '/images/UnknownSong.png'
                              }
                              alt="Song"
                            />
                            <div
                              style={{
                                textAlign: 'start',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              <h4
                                style={{
                                  color: '#BB1C2D',
                                  fontSize: 'clamp(0px,3.7vw,15px)',
                                  fontWeight: 550,
                                  margin: 0,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {song?.name || 'Unknown Song'}
                              </h4>
                              <span
                                style={{
                                  color: '#868686',
                                  fontSize: 'clamp(0px,3.3vw,14px)',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {song?.artists?.[0]?.name || 'Unknown Artist'}
                              </span>
                            </div>
                          </div>

                          <div
                            style={{
                              width: '35%',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'center',
                            }}
                          >
                            <h5
                              style={{
                                color: '#BB1C2D',
                                fontSize: 'clamp(0px,3.5vw,12px)',
                                marginBottom: 0,
                                whiteSpace: 'nowrap',
                                fontWeight: 550,
                              }}
                            >
                              {song?.status === 'rejected'
                                ? 'Declined'
                                : song?.status
                                  ? song.status.charAt(0).toUpperCase() +
                                    song.status.slice(1)
                                  : ''}
                            </h5>

                            {song?.status === 'rejected' && (
                              <span
                                style={{
                                  fontSize: 'clamp(0px,3.2vw,9px)',
                                  color: '#868686',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Reason: Vibe mismatch
                              </span>
                            )}
                          </div>
                        </div>
                        <hr style={{ margin: '0.5rem 0' }} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div
          className="d-flex flex-row justify-content-center align-items-center w-100"
          style={{
            gap: '15px',
            background: 'white',
            height: '73px',
            paddingBottom: '2vh',
            paddingTop: '10px',
            paddingLeft: '10px',
            paddingRight: '10px',
            borderTop: '0.5px solid rgba(175, 175, 175, 0.53)',
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 0,
          }}
        >
          {/* Add Song Button */}
          <button
            className="px-3 py-2"
            style={{
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              background:
                'linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)',
              fontSize: 'clamp(0px,4vw,16px)',
              whiteSpace: 'nowrap',
              position: 'relative',
              flex: djDetails?.isShoutOutDisabled ? 2 : 'unset', // Expand if shout-out disabled
            }}
            onClick={handleAddSong}
            disabled={isButtonLoading}
          >
            Add a Song
          </button>

          {/* Add Shout-Out Button */}
          {!djDetails?.isShoutOutDisabled && (
            <button
              className="px-3 py-2"
              style={{
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                background:
                  'linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)',
                fontSize: 'clamp(0px,4vw,16px)',
                whiteSpace: 'nowrap',
              }}
              onClick={() => {
                if (client) {
                  client.logEvent('addShoutClick', 'clicked', {
                    vID: djDetails?.id || '',
                    vName: djDetails?.name || '',
                    source:
                      localStorage.getItem('isQrEntry') === 'true'
                        ? 'qrScan'
                        : 'null',
                    status: djDetails.status,
                  });
                }
                setIsShoutoutModalOpen(true);
              }}
            >
              Add a Shout-Out
            </button>
          )}

          {/* Heart Button */}
          <button
            className="px-3 py-2"
            style={{
              color: 'white',
              borderRadius: '10px',
              background: 'white',
              fontSize: 'clamp(0px,4vw,16px)',
              whiteSpace: 'nowrap',
              border: '0.5px solid rgb(107, 107, 107)',
            }}
            onClick={() => handleHeartClick()}
          >
            <img
              style={{ width: 'clamp(0px,6vw,24px)' }}
              src="/images/heart.svg"
            />
          </button>
        </div>
      </div>
      {isShoutoutModalOpen && (
        <ShoutoutModal
          isOpen={isShoutoutModalOpen}
          onClose={() => setIsShoutoutModalOpen(false)}
          venueId={vid}
          onSuccess={triggerConfetti}
          venueDetails={djDetails}
        />
      )}
      {showGiftModal && (
        <GiftModal
          show={showGiftModal}
          onClose={() => setShowGiftModal(false)}
          onSuccess={triggerConfetti}
          djName={displayName}
          walletCoins={profile?.coins}
          PartnerId={PartnerId}
          priceData={price}
          venueId={vid || localStorage.getItem('venueId')}
        />
      )}

      {showModal && !userModal && (
        <EngagementModal
          recipientName={selectedRecipient}
          UserName={selectedUserName}
          Thumbnail={selectedThumbnail}
          picture={selectedPicture}
          Description={selectedDescription}
          showSendSameWishButton={showSendSameWishButton}
          onSuccess={triggerConfetti}
          wish={selectedWish}
          venueId={vid || localStorage.getItem('venueId')}
          userCoins={profile?.coins || 0}
          onOpenShoutoutModal={() => setIsShoutoutModalOpen(true)}
          onClose={() => setShowModal(false)}
          venue_status={djDetails?.status}
        />
      )}
      <SocialIconModal
        isOpen={directionModal}
        onClose={() => setDirectionModal(false)}
        socialName={'Maps'}
        href={
          djDetails?.geometry?.coordinates
            ? `https://www.google.com/maps/dir/?api=1&destination=${djDetails.geometry.coordinates[1]},${djDetails.geometry.coordinates[0]}`
            : 'https://www.google.com/maps'
        }
        message="Want to see the directions for the event?"
      />
    </div>
  );
};

export default Event;
